import React from "react";
import { WORLD_LAND_STRIP } from "../globe/worldLandStrip";
import "./HomeGlobe.css";

// Company names, the same in every language.
export const PARTNER = { stripe: "Stripe", masspay: "MassPay" };

// The homepage's Borderless Earnings globe (1.5.2 globe-r2, option A): the
// welcome tour's real Earth (Natural Earth land, Americas facing) as a dark
// sphere with Brand Green land, slowly turning. Two copies of the land strip
// side by side scroll one full width under a circular clip = one turn every
// 48s, forever. Reduce Motion: the Earth stops and only the glow breathes
// (HomeGlobe.css). Decorative: the words beside it say what it means.
const HomeGlobe: React.FC = () => (
  <div className="hg-globe" aria-hidden="true">
    <span className="hg-halo" />
    <div className="hg-orb">
      <svg className="hg-svg" viewBox="0 0 190 190">
        <defs>
          <clipPath id="hg-clip">
            <circle cx="95" cy="95" r="95" />
          </clipPath>
        </defs>
        <g clipPath="url(#hg-clip)">
          <g className="hg-map">
            <path className="hg-land" d={WORLD_LAND_STRIP} />
            <path className="hg-land" d={WORLD_LAND_STRIP} transform="translate(380 0)" />
          </g>
        </g>
      </svg>
      <span className="hg-shade" />
      <span className="hg-shine" />
    </div>
  </div>
);

/** "Secure payouts powered by" + the partners' own white wordmarks (partner
 *  logo rules: official files, unmodified, smaller than our wordmark). */
export const PayoutPartners: React.FC<{ label: string }> = ({ label }) => (
  <div className="hg-partners">
    <p className="hg-partners-by">{label}</p>
    <div className="hg-logos">
      <img className="hg-logo-stripe" src="/stripe-wordmark-white.svg" alt={PARTNER.stripe} />
      <span className="hg-logo-sep" aria-hidden="true" />
      <img className="hg-logo-masspay" src="/masspay-wordmark-white.svg" alt={PARTNER.masspay} />
    </div>
  </div>
);

export default HomeGlobe;
